import LocalGridConfig from "../../../../config/LocalGridConfig";
import { AgGridReact } from "@ag-grid-community/react";
import { AllModules } from "@ag-grid-enterprise/all-modules";
import useStore from "../../../../store";
import { observer } from "mobx-react";
import { Button } from "antd";
import { vsmCommon } from "../../../../config/messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faCheck,
	faTimes
} from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";

const ActionRenderer = observer((props) => {
	const { AUTH } = useStore();
	const {
		openApproveModal,
		openRejectModal
	} = props.agGridReact.props.frameworkComponents;

	return (
		<div className="action-column">
			{AUTH.checkPrivileges("#8602#") && (
				<Button
					type="text"
					title={"Approve"}
					className="viewIcon mr-20"
					size="large"
					style={{ padding: 7 }}
					onClick={() => {
						openApproveModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faCheck} />
				</Button>
			)}
			{AUTH.checkPrivileges("#8603#") && (
				<Button
					type="text"
					title={"Reject"}
					className="deleteIcon"
					size="large"
					style={{ padding: 7 }}
					onClick={() => {
						openRejectModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faTimes} />
				</Button>
			)}
		</div>
	);
});

const HistoryListComponent = observer((props) => {
	const {
		openApproveModal,
		openRejectModal,
	} = props;
	const {
		MunicipalReqHistoryStore: { getList, list_data, setupGrid, onFilterChanged },
	} = useStore();

	const gridOptions = {
		columnDefs: [
			{
				headerName: "Z-Form",
				field: "booking_id",
				filter: "agNumberColumnFilter",
				pinned: "left",
				minWidth: 120,
				width: 120,
			},
			{
				headerName: "Date Time",
				field: "modified",
			},
			{
				headerName: "Location",
				field: "location.name",
			},
			{
				headerName: "Sales Consultant",
				field: "sales_consultant.name",
			},
			{
				headerName: "Address",
				field: "address",
			},
			{
				headerName: "Note",
				field: "note",
				minWidth: 400,
				width: 400
			},
			{
				headerName: "Status",
				field: "status",
			}
		],
	};

	useEffect(() => {
		getList();
	}, [getList]);

	return (
		<div className="ag-theme-alpine grid_wrapper">
			<AgGridReact
				rowHeight={LocalGridConfig.rowHeight}
				headerHeight={LocalGridConfig.headerHeight}
				rowData={list_data}
				modules={AllModules}
				columnDefs={gridOptions.columnDefs}
				defaultColDef={LocalGridConfig.defaultColDef}
				columnTypes={LocalGridConfig.columnTypes}
				overlayNoRowsTemplate={vsmCommon.noRecord}
				frameworkComponents={{
					ActionRenderer,
					openApproveModal,
					openRejectModal,
				}}
				onGridReady={setupGrid}
				gridOptions={LocalGridConfig.options}
				onFilterChanged={onFilterChanged}
				onSortChanged={onFilterChanged}
			/>
		</div>
	);
});

export default HistoryListComponent;
